import type { CoreElement } from '@tunasong/schemas'
import type { TunaEditor, TunaPlugin } from '../plugin-types.js'

const asidePluginsCache = new WeakMap<TunaPlugin[], TunaPlugin[]>()

const getAsidePlugins = (pluginList: TunaPlugin[]) => {
  let cached = asidePluginsCache.get(pluginList)
  if (!cached) {
    cached = pluginList.filter(p => p.components?.SectionAside)
    asidePluginsCache.set(pluginList, cached)
  }
  return cached
}

export const hasSectionAsidePlugins = (editor: TunaEditor) => getAsidePlugins(editor.meta.pluginList).length > 0

/** Render every plugin's `components.SectionAside` for a section. */
export const renderSectionAsides = (editor: TunaEditor, section: CoreElement, label: string) =>
  getAsidePlugins(editor.meta.pluginList).map(plugin => {
    const Aside = plugin.components?.SectionAside
    if (!Aside) {
      return null
    }
    return <Aside key={plugin.key} editor={editor} section={section} label={label} />
  })
